import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Input from '../elements/Input';
import Button from '../elements/Button';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

class ContactForm extends React.Component {

  state = {
    name: '',
    email: '',
    message: '',
    status: 'idle' // idle | sending | success | error
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, message } = this.state;
    this.setState({ status: 'sending' });

    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message })
      });

      if (response.ok) {
        this.setState({ name: '', email: '', message: '', status: 'success' });
      } else {
        this.setState({ status: 'error' });
      }
    } catch (err) {
      this.setState({ status: 'error' });
    }
  }

  render() {
    const { className, ...props } = this.props;
    const { status } = this.state;

    return (
      <div style={contactWrapStyle}>
        <section
          {...props}
          className={classNames('hero section', className)}
        >
          <div className="container">
            <div className="hero-inner section-inner">
              <div className="hero-center-content">
                <div className="hero-badge reveal-from-top" data-reveal-delay="100">
                  Let&apos;s Work Together
                </div>
                <h1 className="mt-16 mb-16 reveal-from-top hero-headline" data-reveal-delay="200">
                  Get in <span className="hero-highlight">Touch</span>
                </h1>
                <p className="hero-subtext mb-40 reveal-from-top" data-reveal-delay="300">
                  Tell us about your project. We&apos;ll follow up within one business day.
                </p>

                <div className="reveal-from-top invert-color" data-reveal-delay="400" style={formCardStyle}>
                  {status === 'success' ? (
                    <div style={successStyle}>
                      ✓ Message sent! We&apos;ll be in touch within one business day.
                    </div>
                  ) : (
                    <form onSubmit={this.handleSubmit}>
                      {status === 'error' && (
                        <div style={errorStyle}>
                          Something went wrong. Please try again or email us directly at{' '}
                          <a href="mailto:matt@autonomyresources.online" style={{ color: '#f87171' }}>
                            matt@autonomyresources.online
                          </a>
                        </div>
                      )}
                      <div className="mb-16">
                        <Input
                          label="Full name"
                          placeholder="Full name"
                          onChange={(e) => this.setState({ name: e.target.value })}
                          value={this.state.name}
                          labelHidden
                          required
                        />
                      </div>
                      <div className="mb-16">
                        <Input
                          type="email"
                          label="Email"
                          placeholder="Email address"
                          onChange={(e) => this.setState({ email: e.target.value })}
                          value={this.state.email}
                          labelHidden
                          required
                        />
                      </div>
                      <div className="mb-24">
                        <Input
                          type="textarea"
                          label="Message"
                          placeholder="Tell us about your project..."
                          onChange={(e) => this.setState({ message: e.target.value })}
                          value={this.state.message}
                          rows={5}
                          labelHidden
                          required
                        />
                      </div>
                      <Button
                        color="primary"
                        wide
                        disabled={status === 'sending'}
                      >
                        {status === 'sending' ? 'Sending…' : 'Send Message'}
                      </Button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="hero-wave">
          <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#ffffff" />
          </svg>
        </div>
      </div>
    );
  }
}

const contactWrapStyle = {
  position: 'relative',
  background: 'linear-gradient(150deg, #0F172A 0%, #1e3a5f 45%, #0e7490 100%)',
  overflow: 'hidden'
};

const formCardStyle = {
  background: 'rgba(255, 255, 255, 0.06)',
  border: '1px solid rgba(255, 255, 255, 0.12)',
  borderRadius: '16px',
  padding: '40px',
  maxWidth: '520px',
  margin: '0 auto',
  textAlign: 'left'
};

const successStyle = {
  background: 'rgba(34, 197, 94, 0.15)',
  border: '1px solid rgba(34, 197, 94, 0.3)',
  borderRadius: '8px',
  padding: '20px 24px',
  color: '#4ade80',
  fontSize: '16px',
  fontWeight: '500',
  textAlign: 'center'
};

const errorStyle = {
  background: 'rgba(239, 68, 68, 0.15)',
  border: '1px solid rgba(239, 68, 68, 0.3)',
  borderRadius: '8px',
  padding: '14px 18px',
  color: '#f87171',
  fontSize: '14px',
  marginBottom: '16px'
};

ContactForm.propTypes = propTypes;
ContactForm.defaultProps = defaultProps;

export default ContactForm;
